import React from 'react';
import Hero from '../components/Hero';
import MeetTutor from '../components/MeetTutor';
import Stats from '../components/Stats';
import Journey from '../components/Journey';
import HowItWorks from '../components/HowItWorks';
import BehindResults from '../components/BehindResults';

const Home = () => {
  return (
    <>
      <Hero />
      <MeetTutor />
      <Stats />
      <Journey />
      <HowItWorks />
      <BehindResults />
    </>
  );
};

export default Home;
